































































import { Component, Prop, Vue } from 'vue-property-decorator'
// @ts-ignore
import { createPopper, Instance, Placement } from '@popperjs/core'
// @ts-ignore
import _, { DebouncedFunc } from 'lodash'
import { Mentionable } from '@/models/Group/Member'

@Component({})
export default class SearchMentionBox extends Vue {
  @Prop({ default: () => [] }) listToSearch!: Mentionable[]
  @Prop({ default: false }) isLoading!: boolean
  @Prop({ default: 'bottom-start' }) popupPosition!: Placement
  @Prop({ default: 'top-start' }) popupFallbackPosition!: Placement
  @Prop({ default: true }) needFallbackPosition!: boolean
  private debouncedSearchToMention!: DebouncedFunc<() => void>

  noAvatar = require('@/assets/images/avatar-default.png')
  searchMember = ''
  isOpen = false
  popperInstance!: Instance | null

  $refs!: {
    triggerRef: HTMLDivElement
    dropdownRef: HTMLElement
  }

  created() {
    this.debouncedSearchToMention = _.debounce(this.handleSearchMember, 300)
  }

  mounted() {
    window.addEventListener('resize', this.updatePosition)
    window.addEventListener('scroll', this.updatePosition, true)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updatePosition, true)
    window.removeEventListener('scroll', this.updatePosition, true)
    this.popperInstance?.destroy()
  }

  clearSearch() {
    this.searchMember = ''
  }

  createPopperInstance() {
    if (!this.$refs.triggerRef || !this.$refs.dropdownRef) return
    if (this.popperInstance) {
      this.popperInstance.destroy()
    }
    this.popperInstance = createPopper(
      this.$refs.triggerRef,
      this.$refs.dropdownRef,
      {
        placement: this.popupPosition,
        modifiers: [
          { name: 'offset', options: { offset: [0, 10] } },
          ...(this.needFallbackPosition
            ? [
                {
                  name: 'flip',
                  options: { fallbackPlacements: [this.popupFallbackPosition] }
                }
              ]
            : [])
        ]
      }
    )
  }

  toggleDropdown() {
    if (this.isOpen) {
      this.closeDropdown()
    } else {
      this.isOpen = true
      this.handleSearchMember()
      this.$nextTick(() => {
        if (this.$refs.dropdownRef) {
          this.$refs.dropdownRef.style.visibility = 'hidden'
          this.createPopperInstance()
          this.updatePosition()
          this.$refs.dropdownRef.style.visibility = 'visible'
        }
      })
    }
  }

  closeDropdown() {
    this.isOpen = false
  }

  updatePosition = () => {
    this.$nextTick(() => {
      this.popperInstance?.update()
    })
  }

  onSearchMember() {
    this.debouncedSearchToMention()
  }

  handleSearchMember() {
    this.$emit('onSearch', this.searchMember.trim())
  }

  onSelectItem(item: Mentionable) {
    this.$emit('onSelect', item)
  }
}
